/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-param-reassign */
/* eslint-disable no-bitwise */
/* eslint-disable no-nested-ternary */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-console */
/* eslint-disable prefer-const */
/* eslint-disable react/button-has-type */
/* eslint-disable react/self-closing-comp */
/* eslint-disable new-cap */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-await-in-loop */
/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import '../../shared/arial';
import AsyncSelect from 'react-select/async';
import { Loading } from '../../helpers/utils';
import groupServices from '../../redux/services/groupServices';
import elearningDetailsServices from '../../redux/services/elearningDetailsServices';
import { toastError, toastSuccess } from '../../redux/actions/alertActions';

const SelectExaminer = ({
  rowData, teachers,
}) => {
  const [examiner, setExaminer] = useState([]);

  const handleSetExaminer = (data) => {
    const teachersTmp = [];
    teachers.forEach((teacher) => {
      if (data.includes(teacher._id)) {
        teachersTmp.push(teacher);
      }
    });
    setExaminer(teachersTmp);
  };

  useEffect(() => {
    if (rowData !== undefined && rowData.examiner !== undefined && teachers !== undefined) {
      handleSetExaminer(rowData.examiner);
    }
  }, [teachers, rowData]);

  const handleExaminer = (e) => {
    const newExaminers = [];
    e.forEach((newExaminer) => {
      newExaminers.push(newExaminer._id);
    });

    groupServices.getGroupWithExam(rowData.groupId)
      .then((res) => {
        const elearningDetails = res.elearning;
        elearningDetails.elearningOptions.forEach((elearningOption) => {
          if (elearningOption._id === rowData.examId) {
            if (elearningOption.examiner !== undefined && elearningOption.examiner.length > 0) {
              elearningOption.examiner = [...newExaminers];
              handleSetExaminer(elearningOption.examiner);
            } else {
              elearningOption.examiner = newExaminers;
              handleSetExaminer(elearningOption.examiner);
            }
          }
        });
        elearningDetailsServices.updateElearningDetails(elearningDetails._id, elearningDetails)
          .then((elearningDetail) => {
            if (elearningDetail !== undefined) {
              toastSuccess('Correcteur(s) modifié(s)');
            } else {
              toastError('La modification du correcteur n\'a pas pu s\'effectuer');
            }
          });
      });
  };

  const loadOptions = (inputValue, callback) => {
    try {
      const regex = new RegExp(inputValue, 'i');
      const filteredTeachers = teachers.filter(
        (teacher) => regex.test(`${teacher.name} ${teacher.firstname}`),
      );
      filteredTeachers.sort((a, b) => ((a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)));
      callback(filteredTeachers);
    } catch (error) {
      callback([]);
    }
  };

  return (
    <>
      {teachers && rowData
        ? (
          <AsyncSelect
            value={examiner || ''}
            placeholder="Correcteur"
            cacheOptions
            defaultOptions={teachers}
            loadOptions={loadOptions}
            getOptionLabel={(option) => `${option.name} ${option.firstname}`}
            getOptionValue={(option) => option._id}
            isMulti
            isClearable
            onChange={(e) => {
              handleExaminer(e);
            }}
          />
        )
        : <Loading />}
    </>
  );
};

export default SelectExaminer;
